import React from 'react';

export const NotFound = () => (
    <div style={{width: '100%', height: 100, display: 'flex', justifyContent: 'center', alignItems: 'center'}}>
        <h1 style={{fontSize: 22}}>No hemos encontrado mas datos.</h1>
    </div>
);